<template>
    <div class="card-menu">
        <span class="material-icons flex-filler menu-icon" @click="toggleActive()">more_vert</span>
        <nav class="menu-items" v-bind:class="{active : active }">
            <slot></slot>
        </nav>
    </div>
</template>

<script>
module.exports = {
    data:function() {
        return {
            active:false
        }
    },
    methods: {
        toggleActive:function() {
            this.active = this.active ? false : true;
        }
    }
}
</script>
